import { createSend } from '../clients';
import { TurnType } from '../types';

export type SendTurnParams = {
	type: TurnType;
	cellIds?: number;
};

export const sendTurn = createSend('turn').prepend<SendTurnParams>((pld) => ({
	...pld,
	cellIds: pld.cellIds === undefined ? pld.cellIds : [pld.cellIds],
}));
